
export default {
  isAPIOnLine: false,
}
